<customer-menu
  *ngIf="currentLang$ | async as lang"
  class="asList"
  [value]="lang.id">
  <customer-menu-item
    *ngFor="let lang of languages"
    [value]="lang.id"
    (click)="languagesService.changeLanguage(lang.id)">
    <mat-icon [svgIcon]="lang.id">
    </mat-icon>
    <span>{{ lang.name | translate }}</span>
  </customer-menu-item>
</customer-menu>
